module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxtDnm4qiMZlH5rhYv_7LI2Y.woff2";